export default {
  APAC: 'Asia Pacific',
} as { [key: string]: string };
